import './Scanbat.scss';

import React from 'react';

import { ROUTE_SCANBAT } from '@/common/constants';
import Aside from '@/ebat/components/blocks/Scanbat/Cart/Aside/Aside';
import Content from '@/ebat/components/blocks/Scanbat/Cart/Content/Content';
import Footer from '@/ebat/components/blocks/Scanbat/Cart/Footer/Footer';
import Header from '@/ebat/components/blocks/Scanbat/Common/Header/Header';
import useManageCarts from '@/ebat/hooks/carts/useManageCarts';

import { ScanbatDefaultProps, ScanbatPropTypes } from './Scanbat.proptypes';
import useScanbat from './useScanbat';

const Scanbat = ({
  cart,
  company,
  disabled,
  isLoading,
  refetchCart,
  warehouse,
}) => {
  const {
    isDisabled: isDisabledUseManageCarts,
    isUpdate,
    localCart,
    onDeleteCartItem,
    onPutCartItems,
    onUpdateLocalCartItem,
  } = useManageCarts({
    cart,
    disabled,
    isLoading,
    refetchCart,
  });

  const { isDisabled, onRemoveWarehouse, onScanBarCode } = useScanbat({
    disabled: disabled || isDisabledUseManageCarts.disabled,
    isLoading: isLoading || isDisabledUseManageCarts.loading,
    localCart,
    refetchCart,
    warehouse,
  });

  return (
    <div className="wrapper wrapper--full">
      <Header
        className="scanbat-page__header"
        company={company}
        disabled={isDisabled.disabled}
        link={ROUTE_SCANBAT}
        onRemoveWarehouse={onRemoveWarehouse}
        warehouse={warehouse}
      />
      <Aside
        cart={localCart}
        className="scanbat-page__aside"
        disabled={isDisabled.disabled}
        isLoading={isDisabled.loading}
        isUpdated={isUpdate()}
        onScanBarCode={onScanBarCode}
        refetchCart={refetchCart}
      />
      <Content
        cart={localCart}
        className="scanbat-page__content"
        currentItems={localCart.items}
        disabled={isDisabled.disabled}
        isLoading={isDisabled.loading}
        isUpdated={isUpdate()}
        onModifyItem={onUpdateLocalCartItem}
        onRemoveItem={onDeleteCartItem}
      />
      <Footer
        className="scanbat-page__footer"
        currentItems={localCart.items}
        disabled={isDisabled.disabled}
        isLoading={isDisabled.loading}
        isUpdated={isUpdate()}
        onPutCartItems={onPutCartItems}
      />
    </div>
  );
};

Scanbat.defaultProps = {
  ...ScanbatDefaultProps,
};

Scanbat.propTypes = {
  ...ScanbatPropTypes,
};

export default Scanbat;
